import birds from "./birds";
import architecture from "./architecture";
import machines from "./machines";
import landscape from "./landscape";
import animals from "./animals";

//const damioselle = { ...birds[7], id: 0, size: "full" };
const yellowrumped = { ...birds[0], id: 0, size: "full" };

const thirtyRock = { ...architecture[1], id: 2 };
const gardur = machines[3];
const latrabjarg = { ...landscape[0], id: 4 };
const basilica = { ...architecture[8], id: 5 };
const lionsgate = { ...architecture[9], id: 1 };
const westernBluebird = { ...birds[2], id: 5, size: "full" };
const arnardrangur = { ...landscape[1], id: 6 };
const horses = { ...animals[1], id: 7 };
const spitfire = { ...machines[3], id: 8, size: "full" };

const home = [
  yellowrumped,
  lionsgate,
  thirtyRock,
  gardur,
  latrabjarg,
  westernBluebird,
  arnardrangur,
  horses,
  spitfire,
  basilica,
];

export default home;
